import React, { Component } from 'react';
import {Card,CardBody,CardTitle,CardText } from 'mdbreact';
import '../css/project.css';
import  Nav from './nav'
import red from '../img/red.png'
import data from '../img/data.png'
import movie from '../img/Movie.png'
//import { View, Mask } from 'mdbreact'
class Project extends Component {
render(){
return(<div>
<Nav/>

<div class="container">

<div class="row">



<div class="col-md-12"> 
<center>
<h1 id="titules3">PROYECTOS</h1>
</center>

</div>
</div>




<div class="row">

<center> 

<div class="pl-md-5 pr-md-5 containerimgpro"> 

<Card class="card" > 
<img  class="img-fluid" src={red} alt="logo"  />
  
  <CardBody>
    <CardTitle tag="h5">DEAFRIEND</CardTitle>
    <CardText>Deafriend es una red social enfocada a la comunidad sorda, este producto fue desarollado con tecnologías como Firebase, React y Boostrap. </CardText>
    <a  target='_blank' rel = "noopener noreferrer" size="sm" href="https://brenduchiz.github.io/react-redsocial/" class="btn btn-yellow">VER MÁS</a>
    <a  target='_blank' rel = "noopener noreferrer" size="sm" href="https://github.com/brenduchiz/react-redsocial"   class="btn btn-primary"  >Código</a>
  </CardBody>
</Card>
</div>

<div class="pr-md-5 containerimgpro"  > 
<Card>
<img  class="img-fluid" src={data} alt="logo"  />
  
  <CardBody>
    <CardTitle tag="h5">DATADASHBOARD</CardTitle>
    <CardText>Datadashboard es un vizualizador de datos de manera ágil y fluida, este producto fue desarollado con tecnologías como JavaScript, CSS, HTML y datos JSON.   </CardText>
    <a  target='_blank' rel = "noopener noreferrer"  size="sm" id="button-code" href="https://brenduchiz.github.io/cdmx-2018-06-bc-core-am-data-dashboard/inicio.html" class="btn btn-yellow" >VER MÁS</a>
     <a  target='_blank' rel = "noopener noreferrer" size="sm" href="https://github.com/brenduchiz/cdmx-2018-06-bc-core-am-data-dashboard"   class="btn btn-primary" >Código</a>
  </CardBody>
</Card>
</div>
<div class="  containerimgpro"  > 
<Card>
<img  class="img-fluid" src={movie} alt="logo"  />
  
  <CardBody>
    <CardTitle tag="h5">API MOVIES</CardTitle>
    <CardText>Api Movies es un catálogo que incluye películas y series con su respectiva descripción, este producto fue desarollado con JavaScript, Boostrap, HTML y API REST </CardText>
    <a  target='_blank' rel = "noopener noreferrer" size="sm" href="https://brenduchiz.github.io/cdmx20181-Track-FE-themovieapi/docs/src/views/login.html"  class="btn btn-yellow" >VER MÁS</a>
    <a  target='_blank' rel = "noopener noreferrer" size="sm" href="https://github.com/brenduchiz/cdmx20181-Track-FE-themovieapi"  class="btn btn-primary">Código</a>
  </CardBody>
</Card>
</div>


</center> 
</div>
</div>

</div>);
}
}
export default Project;